import { Maybe } from 'maybe-not';
import MessageBus from '../utility/message-bus';

export default function getPushEnrollmentSetup(
    messageBus: MessageBus,
    platformCapabilities: Set<string>
) {
    if (!platformCapabilities.has('checkPushEnrollment')) {
        return;
    }

    return function getPushEnrollment(): Promise<{ token: string; nickname: string }> {
        return messageBus
            .sendRequest<{ status: number; message: string; fcmToken: string; nickname: string }>(
                `executeDynamicPlatformAPI`,
                Maybe.just({ functionName: 'checkPushEnrollment', args: [] }).map(JSON.stringify)
            )
            .then(response => {
                if (response.value.status !== 0) {
                    throw new Error(response.value.message);
                }
                return { token: response.value.fcmToken, nickname: response.value.nickname };
            });
    };
}
